/* ════════════ PHOSPHOR RAIN ════════════
   The manifesto page's atmosphere: the stack page's pixel rain,
   but every column falls in phosphor green. One color, one idea. */

import { pixelatePortraits } from "./pixelate";
import { onPage } from "./router";

const REDUCED = matchMedia("(prefers-reduced-motion: reduce)").matches;

function rain(signal: AbortSignal) {
  const c = document.querySelector<HTMLCanvasElement>("#rain")!;
  const ctx = c.getContext("2d")!;

  const SIZE = 3; // pixel block size
  const SPACING = 24; // column spacing

  type Col = { x: number; y: number; v: number; trail: number; wait: number };
  let cols: Col[] = [];

  const reset = (col: Col, first: boolean) => {
    col.y = first ? Math.random() * c.height : -Math.random() * c.height * 0.5;
    col.v = 0.35 + Math.random() * 1.0;
    col.trail = 6 + (Math.random() * 10) | 0;
    col.wait = first ? 0 : 60 + Math.random() * 260;
  };

  const seed = () => {
    c.width = innerWidth;
    c.height = innerHeight;
    cols = Array.from({ length: Math.ceil(c.width / SPACING) }, (_, i) => {
      const col: Col = { x: i * SPACING + 8, y: 0, v: 1, trail: 8, wait: 0 };
      reset(col, true);
      return col;
    });
  };
  seed();
  addEventListener("resize", seed, { signal });

  const draw = () => {
    ctx.clearRect(0, 0, c.width, c.height);
    ctx.fillStyle = "#00ffa3";
    for (const col of cols) {
      if (col.wait > 0) continue;
      for (let i = 0; i < col.trail; i++) {
        const y = col.y - i * SIZE * 2;
        if (y < -SIZE || y > c.height + SIZE) continue;
        ctx.globalAlpha = i === 0 ? 0.85 : (1 - i / col.trail) * 0.4;
        ctx.fillRect(col.x, y | 0, SIZE, SIZE);
      }
    }
    ctx.globalAlpha = 1;
  };

  if (REDUCED) {
    draw();
    return;
  }
  const tick = () => {
    if (signal.aborted) return;
    for (const col of cols) {
      if (col.wait > 0) {
        col.wait--;
        continue;
      }
      col.y += col.v;
      if (col.y - col.trail * SIZE * 2 > c.height) reset(col, false);
    }
    draw();
    requestAnimationFrame(tick);
  };
  tick();
}

onPage((signal) => {
  rain(signal);
  pixelatePortraits();
});
